import { ask } from '@monorepo/tools/src/lib/tools/ask/ask';
import endpoints from './endpoints/index.endpoints';
import { DomainMaxLossCacheEntry } from '../models/domain-max-loss.model';

export type GetDomainMaxLossStatusParams = {
	campaign_id?: number;
	domain?: string;
};

export const DomainMaxLossApi = {
	getDomainMaxLossStatus(params?: GetDomainMaxLossStatusParams): Promise<DomainMaxLossCacheEntry[]> {
		const search = new URLSearchParams();
		if (params?.campaign_id !== undefined) {
			search.set('campaign_id', String(params.campaign_id));
		}
		if (params?.domain) {
			search.set('domain', params.domain);
		}
		return ask.get(endpoints.domainMaxLoss.status(), search);
	},

	unPauseDomains(keys: string[]): Promise<void> {
		return ask.post(endpoints.domainMaxLoss.unPauseDomains(), keys);
	},
};
